module.exports = __webpack_public_path__ + "static/media/05_tn.e5dd36f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/outerborders/thumbnails/05_tn.jpg
// module id = 143
// module chunks = 0